// ©2024 Austin App House. All rights reserved.
import React from 'react';
import FundingSourceCard from './FundingSourceCard';

const Content = ({
  auth, fundingSources = [], handlerVerify, handlerDelete, makePrimary, isLoaded,
}) => (
  <div className="subpage-funding-list">
    {fundingSources && fundingSources.length ? (
      <ul className="payment_list admin-payment-list">
        {fundingSources.map(fundingSource => (
          <li key={fundingSource.id}>
            <FundingSourceCard
              fundingSource={fundingSource}
              handlerVerify={handlerVerify}
              handlerDelete={handlerDelete}
              makePrimary={makePrimary}
              auth={auth}
            />
          </li>
        ))}
      </ul>
    ) : isLoaded ? (
      <p className="subpage-empty">None Bank Info Found</p>
    ) : (
      <p className="subpage-loading" role="status">Loading payment methods…</p>
    )}
  </div>
);

export default Content;
